import { useEffect, useState } from 'react';
import { READY, DRAFT, isPreviewMessage } from '../lib/previewFrame';
import { STUDIO_PANELS } from '../components/appearance/areas';
import { previewMedia } from '../components/appearance/previewParts';

const NO_CATALOG = { listings: [], types: [], categories: [], name: 'Your store' };

/**
 * The page inside the Storefront Studio preview iframe (D51): no shell, just the Studio area's
 * preview (the landing page, or the storefront page with the draft's templates, header, footer
 * and card) at the iframe's own (phone or desktop) width. The draft arrives from the editor by
 * postMessage, so unsaved edits show immediately.
 */
export default function AppearanceFrame() {
  const [draft, setDraft] = useState(null);
  useEffect(() => {
    const origin = window.location.origin;
    const parent = window.parent === window ? undefined : window.parent;
    const onMessage = (e) => {
      if (isPreviewMessage(e, { type: DRAFT, origin, source: parent })) {
        setDraft({ area: e.data.area, doc: e.data.doc, theme: e.data.theme, catalog: e.data.catalog || NO_CATALOG });
      }
    };
    window.addEventListener('message', onMessage);
    if (parent) parent.postMessage({ type: READY }, origin);
    return () => window.removeEventListener('message', onMessage);
  }, []);

  if (!draft || !draft.doc) return <div className="min-h-dvh bg-[var(--app-bg)]" aria-busy="true" />;
  const { Preview } = STUDIO_PANELS[draft.area] || STUDIO_PANELS.home;
  return <Preview area={draft.area} doc={draft.doc} theme={draft.theme} media={previewMedia} catalog={draft.catalog} />;
}
